import BaseChargeBack from '../BaseChargeBack/BaseChargeBack';

function Awaitingresponse() {
	return <BaseChargeBack chargebackStatus="Awaiting Response" />
}

export default Awaitingresponse;
